import { CustomButton, CustomCollapseCard, CustomTable, Text } from '@src/components';
import React, { useCallback, useEffect } from 'react';
import { useText } from '@src/components';

import '@src/styles/pendingApproval/balanceOrder.scss';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from '@src/utils/day';
import { formatPlate } from '@src/utils/utils';
import { getCardApprovalList, updateCardApproval } from '@src/store/slice/ticketCarCardOrderSlice';
import CustomIconComponent from '@src/components/CustomIconComponent';
import { getPendingNotifications } from '@src/store/slice/notificationSlice';
import { notification, Spin } from 'antd';
const TicketCarCardOrderList = () => {
  const transactionSuccessfullyCompleted2 = useText('transactionSuccessfullyCompleted2');
  const confirmDelivery = useText('confirmDelivery');
  const dispatch = useDispatch();

  const [api, contextHolder] = notification.useNotification();
  const { cardOrderList, updateCardOrderList, loading } = useSelector(
    (state) => state?.ticketCarCardOrder,
  );
  const { processType } = useSelector((state) => state?.packages);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { menus } = useSelector((state) => state?.menus);
  const { currentUser } = useSelector((state) => state?.user);
  const shouldSkipApprovalAuth =
    currentUser?.userTypeId === 4 && Array.isArray(menus) && menus.some((menu) => menu?.id === 69 || menu?.id === 82);

  useEffect(() => {
    if (processType === 5 || processType === 0) loadCardOrders();
  }, [processType]);

  useEffect(() => {
    if (updateCardOrderList) {
      api.success({
        message: confirmDelivery,
        description: transactionSuccessfullyCompleted2,
        duration: 2,
      });
      dispatch(getCardApprovalList());
    }
  }, [updateCardOrderList]);

  const loadCardOrders = useCallback(() => {
    dispatch(getCardApprovalList());
  }, [dispatch, selectedCustomer]);

  const handleApprovedOrder = async (item) => {
    await dispatch(updateCardApproval({ vehicleDetailId: item.vehicleDetailId }));
    await dispatch(getPendingNotifications({ vouId: 4 }));
  };

  const dataSourceWithId = cardOrderList.map((item, index) => ({
    ...item,
    id: index + 1, // index + 1 kullanarak sıfırdan başlamayan bir id ataması yapıyoruz
  }));

  const columnsCard = [
    {
      title: <Text t="requestNumber" />,
      dataIndex: 'id',
      key: 'id',
      width: '20%',
      className: 'custom-id-column',
    },
    {
      title: <Text t="provider2" />,
      dataIndex: 'providerType',
      key: 'providerType',
      render: (_, record) => {
        const vouId = record.providerType;
        const IconComponent = CustomIconComponent({ providerType: vouId });
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {IconComponent && (
              <img
                src={IconComponent}
                alt={record.provider}
                style={{ width: 24, height: 24, marginRight: 8 }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: <Text t="licensePlate" />,
      dataIndex: 'plate',
      key: 'plate',
      width: '20%',
      responsive: ['md'],
      render: (text) => formatPlate(text),
    },
    {
      title: <Text t="transactionDate2" />,
      dataIndex: 'insertTime',
      key: 'insertTime',
      width: '20%',
      responsive: ['md'],
      render: (text) => {
        return (
          <div>
            <div>{dayjs(text).format('DD/MM/YYYY HH:mm')}</div>
          </div>
        );
      },
    },
    {
      title: <Text t="deliveryAddressUpperCase" />,
      dataIndex: 'deliveryAddressId',
      key: 'deliveryAddressId',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      responsive: ['md'],
      render: (_, record) => {
        return (
          <div className="row-btn-actions">
            <CustomButton
              id="pendingApproval-cardOrderList-custom-second-btn-approved"
              onClick={() => handleApprovedOrder(record)}
              className="custom-btn-approved custom-btn-approved-huge"
              {...(shouldSkipApprovalAuth
                ? {}
                : { buttonAuthName: 'ApprovalAuthorizationGroup' })}
            >
              <Text t="confirmDelivery" />
            </CustomButton>
          </div>
        );
      },
    },
  ];

  return (
    <CustomCollapseCard
      className="card-order-card"
      cardTitle={<Text t="ticketCarFuelCardDeliveryConfirmation" />}
    >
      {contextHolder}
      {loading.updateCardOrderList ? (
        <div className="loading-container" style={{ textAlign: 'center', padding: '250px' }}>
          <Spin size="large" className="custom-spin" />
        </div>
      ) : (
        <CustomTable
          pagination={false}
          isScroll={false}
          dataSource={dataSourceWithId}
          columns={columnsCard}
          rowKey={(record) => `list-${record?.id}`}
        />
      )}
    </CustomCollapseCard>
  );
};

export default TicketCarCardOrderList;
